import { Redirect } from "@shopify/app-bridge/actions"
import { getSessionToken } from "@shopify/app-bridge-utils"
import axios, { AxiosRequestConfig } from "axios"
import qs from "qs"

import { isShopifyEmbedded } from "@/utils/app-bridge"
import AppBridge from "@/utils/app-bridge"
import dayjs from "@/utils/dayjs"
import MockData from "@/utils/mock-data"
import { IAppBridgeHelper } from "@/utils/types/app-bridge-helper"
import { IMockLoginJWT, IMockUriQuery } from "@/utils/types/string-helper"

import EnvHelper from "./env-helper"

let localToken = ""
class AppBridgeHelper implements IAppBridgeHelper {
  async getToken() {
    let token = ""

    if (window.ManageParams.from === "admin") {
      token = window.ManageParams["auth-token"]
    } else if (isShopifyEmbedded()) {
      token = await getSessionToken(AppBridge.app())
    } else {
      if (!localToken) {
        const res = await axios.post<{ token: string }>(
          "https://api-return-test-go.parcelpanel.com/auth/token",
          {
            client: "b",
            uid: +import.meta.env.VITE_MOCK_LOGIN_UID,
            pwd: import.meta.env.VITE_TOKEN_PWD,
          },
        )
        localToken = res.data.data
      }
      token = localToken
    }
    return `Bearer ${token}`
  }

  async getSessionToken(request: AxiosRequestConfig): Promise<any> {
    const token = await this.getToken()
    if (request.headers) {
      request.headers.Authorization = token
    }
    return request
  }

  redirectRemoteDispatch(url: string, newContext = false): void {
    if (EnvHelper.enableHttpReplaceHttps) {
      // http 替换为 https
      url = url.replace("http://", "https://")
    }

    if (isShopifyEmbedded()) {
      AppBridge.redirect().dispatch(Redirect.Action.REMOTE, { newContext, url })
      return
    }

    newContext ? window.open(url, "_blank") : (window.location.href = url)
  }

  // redirectPreviewPage(){
  //   this.redirectRemoteDispatch(stores.UserInfoStore.popupPreviewUrl, true)
  // }

  redirectCustomers(customerID: number) {
    if (isShopifyEmbedded()) {
      AppBridge.redirect().dispatch(Redirect.Action.ADMIN_PATH, {
        newContext: true,
        path: `/customers/${customerID === 0 ? "" : customerID}`,
      })
      return
    }

    // this.redirectRemoteDispatch(stores.UserInfoStore.getCustomerURL(customerID), true)
  }

  private handleMockJWTData(): IMockLoginJWT {
    const uid = parseInt(EnvHelper.mockLoginUid + "" || "1"),
      env = EnvHelper.env || "local",
      exp = dayjs().add(1, "year").unix()

    const data = { env, exp, uid } as IMockLoginJWT
    const parsedQs = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
      strictNullHandling: true,
    }) as IMockUriQuery

    // 清理 Mock 数据
    if ("true" === parsedQs.cleanMockData) {
      MockData.clear()
    }

    // 如果存在模拟数据
    if (MockData.exist() && "true" !== parsedQs.isMockData) {
      return MockData.get()
    }

    // 如果不是设置模拟数据, 返回默认数据
    if ("true" !== parsedQs.isMockData) {
      return data
    }

    // 如果存在模拟数据，就设置值
    const mockData: IMockLoginJWT = {
      env,
      exp: parseInt(parsedQs?.exp ?? exp + ""),
      uid: parseInt(parsedQs?.uid ?? uid + ""),
    }

    MockData.set(mockData)

    return mockData
  }
}

export default new AppBridgeHelper()
